<script setup lang="ts">
import SkeletonBlock from './SkeletonBlock.vue'

withDefaults(
  defineProps<{
    rows?: number
    showAvatar?: boolean
    minHeight?: string
  }>(),
  {
    rows: 6,
    showAvatar: false,
    minHeight: '240px',
  },
)
</script>

<template>
  <div class="sk-detail-panel" :style="{ minHeight }" aria-busy="true" aria-label="详情加载中">
    <div v-if="showAvatar" class="sk-detail-panel__avatar-row">
      <SkeletonBlock variant="circle" width="72px" height="72px" />
      <div class="sk-detail-panel__avatar-meta">
        <SkeletonBlock variant="title" width="120px" />
        <SkeletonBlock variant="text" width="180px" />
      </div>
    </div>
    <div v-for="i in rows" :key="i" class="sk-detail-panel__row">
      <SkeletonBlock variant="text" width="88px" class="sk-detail-panel__label" />
      <SkeletonBlock
        variant="text"
        :width="i % 3 === 0 ? '55%' : '72%'"
        class="sk-detail-panel__value"
      />
    </div>
  </div>
</template>

<style scoped>
.sk-detail-panel {
  padding: 8px 4px 4px;
}

.sk-detail-panel__avatar-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.sk-detail-panel__avatar-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sk-detail-panel__row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid var(--ds-border-subtle);
}

.sk-detail-panel__row:last-child {
  border-bottom: none;
}

.sk-detail-panel__label {
  flex-shrink: 0;
}

.sk-detail-panel__value {
  flex: 1;
  min-width: 0;
}

@media (max-width: 575px) {
  .sk-detail-panel__row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .sk-detail-panel__value {
    width: 100% !important;
  }
}
</style>
